import { Component } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service-type chooser shown at `/services/select`. Replaces ziti-console-lib's
 * `CardListComponent` so a third "From Template" option can be offered alongside
 * Simple and Advanced, while keeping the same look and back/ESC affordances.
 */
@Component({
    selector: 'netfoundry-ui-service-card-list',
    templateUrl: './service-card-list.component.html',
    styleUrls: ['./service-card-list.component.scss'],
    standalone: false,
})
export class ServiceCardListComponent {
    constructor(private router: Router) {}

    back(): void {
        this.router.navigateByUrl('/services');
    }

    chooseSimple(): void {
        this.router.navigateByUrl('/services/simple');
    }

    chooseAdvanced(): void {
        this.router.navigateByUrl('/services/advanced');
    }
}
